<script setup lang="ts">
import { onMounted, ref } from 'vue'
import { NButton, NSpin, NTabPane, NTabs } from 'naive-ui'
import RouteShell from './RouteShell.vue'
import AdminReminderList from './AdminReminderList.vue'
import AdminScheduleList from './AdminScheduleList.vue'
import { useRemindersStore } from '../stores/reminders'
import { useDocumentTitle } from '../composables/useDocumentTitle'

// The one-time-reminder and recurring-schedule sections are split into
// their own components (#1092, formerly inline here) — this view just
// owns the top-level loading/error state and the tab wrapper.

const store = useRemindersStore()
useDocumentTitle('Reminders')

const tab = ref<'schedules' | 'one-time'>('one-time')

onMounted(async () => {
  try {
    await store.fetchAll('pending')
  } catch {
    // loadError surfaces in the template
  }
})
</script>

<template>
  <RouteShell>
    <section class="max-w-3xl mx-auto flex flex-col gap-4 pb-6">
      <header class="flex flex-col gap-1">
        <h1 class="text-2xl font-semibold text-white m-0">Reminders</h1>
        <p class="text-sm text-white/60 m-0">Manage recurring schedules and one-time reminder tasks.</p>
      </header>

      <div v-if="store.loading" class="flex items-center justify-center py-12">
        <NSpin aria-label="Loading…" />
      </div>
      <div v-else-if="store.loadError" class="flex flex-col items-center gap-3 py-12">
        <p class="text-red-400 text-sm m-0">{{ store.loadError }}</p>
        <NButton size="small" @click="store.fetchAll()">Try again</NButton>
      </div>

      <NTabs v-else v-model:value="tab" type="segment" animated>
        <NTabPane name="one-time" tab="One-time">
          <AdminReminderList />
        </NTabPane>

        <NTabPane name="schedules" tab="Schedules">
          <AdminScheduleList />
        </NTabPane>
      </NTabs>
    </section>
  </RouteShell>
</template>
